import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import {
  Select,
  SelectTrigger,
  SelectValue,
} from "@arcadeai/design-system/components/ui/atoms/select";
import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@arcadeai/design-system/components/ui/atoms/table";
import { ChevronsUpDown, Loader2, Settings2 } from "lucide-react";
import { ListLayout } from "@/components/custom/list-layout/list-layout";

export function AccountsTableSkeleton() {
  return (
    <ListLayout
      description="View and manage connected users"
      title="Connected users"
    >
      <div className="space-y-4">
        {/* AccountsTableToolbar skeleton */}
        <div className="flex items-center justify-between">
          <div className="flex flex-1 items-center space-x-2">
            <Input
              className="h-8 w-[150px] lg:w-[250px]"
              disabled
              placeholder="Search accounts..."
            />
          </div>
          <Button disabled size="sm" variant="outline">
            <Settings2 className="mr-2 h-4 w-4" />
            Columns
          </Button>
        </div>

        {/* DataTableContent skeleton */}
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>
                  <div className="flex items-center space-x-2">
                    <Button
                      className="-ml-3 h-8"
                      disabled
                      size="sm"
                      variant="ghost"
                    >
                      <span>Name</span>
                    </Button>
                    <Button
                      className="h-8"
                      disabled
                      size="icon"
                      variant="ghost"
                    >
                      <ChevronsUpDown className="h-4 w-4" />
                    </Button>
                  </div>
                </TableHead>
                <TableHead>
                  <div className="flex items-center space-x-2">
                    <Button
                      className="-ml-3 h-8"
                      disabled
                      size="sm"
                      variant="ghost"
                    >
                      <span>User ID</span>
                    </Button>
                    <Button
                      className="h-8"
                      disabled
                      size="icon"
                      variant="ghost"
                    >
                      <ChevronsUpDown className="h-4 w-4" />
                    </Button>
                  </div>
                </TableHead>
                <TableHead>
                  <div className="flex items-center space-x-2">
                    <Button
                      className="-ml-3 h-8"
                      disabled
                      size="sm"
                      variant="ghost"
                    >
                      <span>Provider</span>
                    </Button>
                    <Button
                      className="h-8"
                      disabled
                      size="icon"
                      variant="ghost"
                    >
                      <ChevronsUpDown className="h-4 w-4" />
                    </Button>
                  </div>
                </TableHead>
                <TableHead>
                  <div className="flex items-center space-x-2">
                    <Button
                      className="-ml-3 h-8"
                      disabled
                      size="sm"
                      variant="ghost"
                    >
                      <span>Scopes</span>
                    </Button>
                    <Button
                      className="h-8"
                      disabled
                      size="icon"
                      variant="ghost"
                    >
                      <ChevronsUpDown className="h-4 w-4" />
                    </Button>
                  </div>
                </TableHead>
                <TableHead>
                  <div className="flex items-center space-x-2">
                    <Button
                      className="-ml-3 h-8"
                      disabled
                      size="sm"
                      variant="ghost"
                    >
                      <span>Status</span>
                    </Button>
                    <Button
                      className="h-8"
                      disabled
                      size="icon"
                      variant="ghost"
                    >
                      <ChevronsUpDown className="h-4 w-4" />
                    </Button>
                  </div>
                </TableHead>
                <TableHead>
                  <div className="flex items-center space-x-2">
                    <Button
                      className="-ml-3 h-8"
                      disabled
                      size="sm"
                      variant="ghost"
                    >
                      <span>Actions</span>
                    </Button>
                    <Button
                      className="h-8"
                      disabled
                      size="icon"
                      variant="ghost"
                    >
                      <ChevronsUpDown className="h-4 w-4" />
                    </Button>
                  </div>
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell className="h-24 text-center" colSpan={6}>
                  <div className="flex items-center justify-center">
                    <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>

        {/* DataTablePagination skeleton */}
        <div className="flex items-center justify-between gap-4 px-2">
          <div className="flex flex-1 items-center space-x-2">
            <div className="flex items-center space-x-2">
              <p className="font-medium text-sm">Rows per page</p>
              <Select disabled>
                <SelectTrigger className="h-8 w-[70px]">
                  <SelectValue placeholder="10" />
                </SelectTrigger>
              </Select>
            </div>
          </div>
          <div className="flex items-center space-x-6 lg:space-x-8">
            <div className="flex w-[100px] items-center justify-center font-medium text-sm">
              Page 1 of 1
            </div>
            <div className="flex items-center space-x-2">
              <Button
                className="hidden h-8 w-8 p-0 lg:flex"
                disabled
                variant="outline"
              >
                <Skeleton className="h-4 w-4" />
              </Button>
              <Button className="h-8 w-8 p-0" disabled variant="outline">
                <Skeleton className="h-4 w-4" />
              </Button>
              <Button className="h-8 w-8 p-0" disabled variant="outline">
                <Skeleton className="h-4 w-4" />
              </Button>
              <Button
                className="hidden h-8 w-8 p-0 lg:flex"
                disabled
                variant="outline"
              >
                <Skeleton className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </ListLayout>
  );
}
